// Barra de navegação principal (canvas): Jogar, Ligas, Amigos e Perfil. Some na sala e na mesa. No celular, fica nas
// 4 telas principais: em pé, embaixo; deitado, coluna à esquerda. No computador (janela com 1024 px ou mais de largura),
// vira o trilho fixo à esquerda em todas as telas fora da sala e da mesa, com o símbolo da marca no topo e a aba da
// tela aberta acesa. O ícone Amigos mostra um ponto dourado com o número de pedidos de amizade recebidos, que vem da
// presença. Quem está no Grátis ganha o item ASSINAR em laranja (item 59.2): no centro da barra no celular e no fim do
// trilho no computador. Ele abre Planos no Mensal com o Bronze em evidência.
import { type ReactNode, useContext, useEffect, useState } from 'react';
import { Marca } from '@truco6/ui/Marca';
import { IconeAmigos } from './BotaoAmizade.tsx';
import { usePresenca } from './presenca.ts';
import { abaDaTela, TELAS_COM_NAVEGACAO, type TelaComNavegacao } from './abas.ts';
import { noGratis, toqueEmAssinar, useLimite } from './limite.ts';
import { abrirPlanosNoBronze, PlanoDaCasca } from './SeloGratis.tsx';
import { ir, type Rota } from './rotas.ts';

// Computador: janela com 1024 px ou mais de largura (o ponto de quebra da casca, por largura e nunca pela orientação).
const COMPUTADOR = '(min-width: 1024px)';
export function useComputador(): boolean {
  const [sim, setSim] = useState(() => typeof matchMedia === 'function' && matchMedia(COMPUTADOR).matches);
  useEffect(() => {
    if (typeof matchMedia !== 'function') return;
    const m = matchMedia(COMPUTADOR), f = () => setSim(m.matches);
    f();
    m.addEventListener('change', f);
    return () => m.removeEventListener('change', f);
  }, []);
  return sim;
}

const svg = (filhos: ReactNode) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{filhos}</svg>
);
const ICONES: Record<TelaComNavegacao, ReactNode> = {
  inicio: svg(<><rect x="3" y="5" width="11" height="15" rx="2" transform="rotate(-8 8.5 12.5)" /><rect x="10" y="4" width="11" height="15" rx="2" transform="rotate(8 15.5 11.5)" /></>),
  ranking: svg(<><path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0z" /><path d="M7 6H4v2a3 3 0 0 0 3 3M17 6h3v2a3 3 0 0 1-3 3" /></>),
  amigos: <IconeAmigos tamanho={24} />,
  perfil: svg(<><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" /></>),
};
const ROTULOS: Record<TelaComNavegacao, string> = { inicio: 'Jogar', ranking: 'Ligas', amigos: 'Amigos', perfil: 'Perfil' };

const COROA = svg(<><path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5z" /><path d="M5 19h14" /></>);

export function Navegacao({ tela }: { tela: Rota['tela'] }) {
  const { pedidos } = usePresenca();
  const plano = useContext(PlanoDaCasca), limite = useLimite();
  const gratis = !!plano && noGratis(plano, limite);
  const ativa = abaDaTela(tela, gratis);
  const assinar = gratis && (
    <button key="assinar" className={'assinar-nav' + (ativa === 'assinar' ? ' on' : '')} aria-current={tela === 'planos' ? 'page' : undefined}
      onClick={() => { toqueEmAssinar('menu'); abrirPlanosNoBronze(); }}>
      <span className="icone-nav">{COROA}</span>
      <span className="rotulo-nav">ASSINAR</span>
    </button>
  );
  return (
    <nav className={'navegacao' + (gratis ? ' com-assinar' : '')} aria-label="Navegação principal">
      {/* O símbolo da marca no topo do trilho, só no computador. */}
      <button className="marca-nav" aria-label="Truco de 6, início" onClick={() => { if (tela !== 'inicio') ir({ tela: 'inicio' }); }}>
        <Marca variante="simbolo" altura={40} />
      </button>
      {TELAS_COM_NAVEGACAO.map((t, i) => {
        const aviso = t === 'amigos' && pedidos > 0;
        const rotulo = aviso ? `${ROTULOS[t]}, ${pedidos} ${pedidos === 1 ? 'pedido de amizade' : 'pedidos de amizade'}` : ROTULOS[t];
        return [i === 2 && assinar, (
          <button key={t} className={t === ativa ? 'on' : undefined} aria-current={t === tela ? 'page' : undefined} aria-label={rotulo}
            onClick={() => { if (t !== tela) ir({ tela: t } as Rota); }}>
            <span className="icone-nav">
              {ICONES[t]}
              {aviso && <span className="ponto-nav" aria-hidden="true">{pedidos > 99 ? '99+' : pedidos}</span>}
            </span>
            <span className="rotulo-nav" aria-hidden="true">{ROTULOS[t]}</span>
          </button>
        )];
      })}
    </nav>
  );
}
